/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadDiagnoses } from './LeadDiagnoses';
import {
    LeadDiagnosesFromJSON,
    LeadDiagnosesFromJSONTyped,
    LeadDiagnosesToJSON,
} from './LeadDiagnoses';

/**
 * 
 * @export
 * @interface GetLeadDiagnoses200Response
 */
export interface GetLeadDiagnoses200Response {
    /**
     * 
     * @type {LeadDiagnoses}
     * @memberof GetLeadDiagnoses200Response
     */
    data?: LeadDiagnoses;
}

/**
 * Check if a given object implements the GetLeadDiagnoses200Response interface.
 */
export function instanceOfGetLeadDiagnoses200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetLeadDiagnoses200ResponseFromJSON(json: any): GetLeadDiagnoses200Response {
    return GetLeadDiagnoses200ResponseFromJSONTyped(json, false);
}

export function GetLeadDiagnoses200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeadDiagnoses200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : LeadDiagnosesFromJSON(json['data']),
    };
}

export function GetLeadDiagnoses200ResponseToJSON(value?: GetLeadDiagnoses200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': LeadDiagnosesToJSON(value.data),
    };
}

